export enum ClientDetailTabs {
  leads = 'leads',
  meetings = 'meetings',
  lots = 'lots',
  // TODO: Вернуть при разработке «История обращений».
  // appealsHistory = 'appeals_history',
}

const CLIENT_DETAIL_TABS = new Set<string>(Object.values(ClientDetailTabs));

export const isClientDetailTab = (tab: string | undefined): tab is ClientDetailTabs =>
  Boolean(tab && CLIENT_DETAIL_TABS.has(tab));

export const getClientDetailTab = (tab: string | undefined, showLots: boolean): ClientDetailTabs => {
  if (tab === ClientDetailTabs.lots && !showLots) {
    return ClientDetailTabs.leads;
  }

  if (isClientDetailTab(tab)) {
    return tab;
  }

  return ClientDetailTabs.leads;
};

export const clientDetailTabsMap = [
  {
    value: ClientDetailTabs.leads,
    label: 'Заявки',
  },
  {
    value: ClientDetailTabs.meetings,
    label: 'Встречи',
  },
  {
    value: ClientDetailTabs.lots,
    label: 'Бронирования',
  },
  // TODO: Вернуть при разработке «История обращений».
  // {
  //   value: ClientDetailTabs.appealsHistory,
  //   label: 'История обращений',
  // },
];
